/** Leave the frame callbacks before starting optional work, so the browser can paint. */
export function afterPaint(work: () => void): () => void {
  let timer = 0
  let frame = requestAnimationFrame(() => {
    frame = requestAnimationFrame(() => { timer = window.setTimeout(work, 0) })
  })
  return () => { cancelAnimationFrame(frame); window.clearTimeout(timer) }
}
